const shopWomens = [
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/files/tops-01_copy.jpg?v=1667987961&width=360',
        title:'Tops'
    },
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/files/Tee-01.jpg?v=1667898427&width=360',
        title:'T-Shirts'
    },
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/files/shorts_women-01.jpg?v=1667898316&width=360',
        title:'Shorts'
    },
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/files/leggings-01.jpg?v=1667899318&width=360',
        title:'Leggings'
    },
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/files/sweats_women-01.jpg?v=1667898406&width=360',
        title:'Sweatshirts'
    },
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/files/SBRA2-01.jpg?v=1667988040&width=360',
        title:'Sports Bra'
    }
]

const shopMens = [
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/files/Untitled-6-01.jpg?v=1667985899&width=360',
        title:'T-Shirts'
    },
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/files/KOOVS_20OCT22-1025.jpg?v=1667897521&width=360',
        title:'Jackets'
    },
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/files/KOOVS_20OCT22-0291.jpg?v=1667985664&width=360',
        title:'Pants'
    },
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/files/ball_sweatshirt-01.jpg?v=1668170499&width=360',
        title:'Sweatshirts'
    },
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/files/unisex_accessories-01.jpg?v=1668170734&width=360',
        title:'Accessories'
    },
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/files/shortsn-01.jpg?v=1667897412&width=360',
        title:'Shorts'
    }
]

const varsityJackets = [
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/CataloguetemplateKOOVS-02_5fd99dfc-16fe-4490-af5a-cde1accd1fad.jpg?v=1679399518&width=360',
        imgOnHover:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/CataloguetemplateKOOVS-06_c7687641-5cd0-4976-8a8d-190b1b061121.jpg?v=1679399518&width=360',
        brandClub:'THE COUTURE CLUB',
        title:'Bandana Print Distressed Denim Jacket - Blue Wash',
        salePrice:'Rs. 2,590.00',
        regularPrice:'Rs. 5,180.00'
    },
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/TCCM2202BLUE0361_800x_97dbc06c-0d25-4317-8084-ec6395e1f7a1.webp?v=1671193628&width=360',
        imgOnHover:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/TCCM2202BLUE0368_1600x_b8d04acd-6cc4-4a03-aeb3-a7bf0a2c229e.webp?v=1677043616&width=360',
        brandClub:'THE COUTURE CLUB',
        title:'Distorted Smile Varsity Jacket - Yellow',
        salePrice:'Rs. 7,000.00',
        regularPrice:'Rs. 10,000.00'
    },
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/HEARTMULTIBADGEVARSITYJACKET-GREEN2_800x_deb2ced1-7f5f-4db5-b0c3-5dfa87e8432c.webp?v=1671193716&width=360',
        imgOnHover:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/Selects12396_800x_jpg.webp?v=1677042743&width=360',
        brandClub:'THE COUTURE CLUB',
        title:'Bandana Print Distressed Denim Jacket - Blue Wash',
        salePrice:'Rs. 7,000.00',
        regularPrice:'Rs. 10,000.00'
    },
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/T3M21-10GREEN_b_800x_07c40885-d4fb-4c9b-87bf-2863cc823c4c.jpg?v=1671193412&width=360',
        imgOnHover:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/T3M21-10GREEN_d_800x_60d66828-31a2-4032-95ad-50db48a5360e.jpg?v=1677043853&width=360',
        brandClub:'THE COUTURE CLUB',
        title:'Bandana Print Distressed Denim Jacket - Blue Wash',
        salePrice:'Rs. 7,420.00',
        regularPrice:'Rs. 10,600.00'
    },
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/TCCM1699-BLACK1012_800x_ae4006da-33a3-4045-a25f-3a102190576c.jpg?v=1671193508&width=360',
        imgOnHover:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/TCCM1699-BLACK1018_800x_4b394419-e80a-4551-bfc4-b4bc53dcce79.jpg?v=1677043773&width=360',
        brandClub:'THE COUTURE CLUB',
        title:'Bandana Print Distressed Denim Jacket - Blue Wash',
        salePrice:'Rs. 7,000.00',
        regularPrice:'Rs. 10,000.00'
    },
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/EmptyName_b_800x_38bd8e73-b704-47d2-a977-4c998cc8ec68.webp?v=1671193746&width=360',
        imgOnHover:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/EmptyName_a_2667x_c73a3579-268b-4318-b350-7efb4b3000d1.webp?v=1677043645&width=360',
        brandClub:'THE COUTURE CLUB',
        title:'Bandana Print Distressed Denim Jacket - Blue Wash',
        salePrice:'Rs. 7,000.00',
        regularPrice:'Rs. 10,000.00'
    },
]

const artistCollabs = [
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/front_ac6bf522-8e1b-45a0-b7cc-5b124b54f60e.png?v=1677043959&width=360',
        imgOnHover:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/flying_1_81a09db1-3be4-43c4-9a50-cd61742b9f6b.png?v=1677043959&width=533',
        title:'Bless My Feed T-shirt (Sushi)',
        salePrice:'Rs.1,690.00'
    },
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/latestpsd2.png?v=1677041914&width=533',
        imgOnHover:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/latestpsd2.png?v=1677041914&width=533',
        title:'Bless My Feed T-shirt (Sushi)',
        salePrice:'Rs.1,690.00'
    },
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/back.png?v=1677033793&width=533',
        imgOnHover:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/front_1_2c80b701-3c8a-48bc-b4eb-9c4727e990e9.png?v=1676442568&width=533',
        title:'Bless my feed Coin Bucket Hat',
        salePrice:'Regular priceRs. 1,490.00'
    },
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/front_c3ed41d7-8a48-40b6-b7d2-033adcc269f3.png?v=1675419377&width=533',
        imgOnHover:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/back_1_d551e687-c2a8-426d-bb72-3b9d461cf0e2.png?v=1677044692&width=533',
        title:'Gram Worthy Sweatshirt',
        salePrice:'Rs. 1,890.00'
    },
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/front_d96474c0-bd55-41ce-8d38-7e13404dbd3b.png?v=1675420104&width=533',
        imgOnHover:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/back_92b1687d-3727-4557-b093-cd4d5c09138a.png?v=1677043859&width=533',
        title:'Bless My Feed Hoodie',
        salePrice:'Rs. 2,290.00'
    },
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/front_ac6bf522-8e1b-45a0-b7cc-5b124b54f60e.png?v=1677043959&width=360',
        imgOnHover:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/flying_1_81a09db1-3be4-43c4-9a50-cd61742b9f6b.png?v=1677043959&width=533',
        title:'Bless My Feed T-shirt (Sushi)',
        salePrice:'Rs.1,690.00'
    },
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/latestpsd2.png?v=1677041914&width=533',
        imgOnHover:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/latestpsd2.png?v=1677041914&width=533',
        title:'Bless My Feed T-shirt (Sushi)',
        salePrice:'Rs.1,690.00'
    },
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/back.png?v=1677033793&width=533',
        imgOnHover:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/front_1_2c80b701-3c8a-48bc-b4eb-9c4727e990e9.png?v=1676442568&width=533',
        title:'Bless my feed Coin Bucket Hat',
        salePrice:'Regular priceRs. 1,490.00'
    },
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/front_c3ed41d7-8a48-40b6-b7d2-033adcc269f3.png?v=1675419377&width=533',
        imgOnHover:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/back_1_d551e687-c2a8-426d-bb72-3b9d461cf0e2.png?v=1677044692&width=533',
        title:'Gram Worthy Sweatshirt',
        salePrice:'Rs. 1,890.00'
    },
    {
        img:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/front_d96474c0-bd55-41ce-8d38-7e13404dbd3b.png?v=1675420104&width=533',
        imgOnHover:'https://cdn.shopify.com/s/files/1/0677/1464/6315/products/back_92b1687d-3727-4557-b093-cd4d5c09138a.png?v=1677043859&width=533',
        title:'Bless My Feed Hoodie',
        salePrice:'Rs. 2,290.00'
    }
]


export {shopMens,shopWomens,varsityJackets,artistCollabs}